import { FC } from "react";
import { StyledDivider } from "./style";

const Divider: FC = ({ children }) => {
    return <StyledDivider>{children}</StyledDivider>;
};

export default Divider;
